<template>
  <div class="register-page">
    <LoginHeader />

    <main class="flex-grow flex items-center justify-center py-16">
      <div class="container">
        <div class="flex flex-col md:flex-row items-center justify-center gap-12">
          <div class="hidden md:block md:w-1/2 fade-in-up" style="animation-delay: 0.2s;">
            <div class="w-full max-w-md mx-auto">
              <img
                src="../assets/images/login.png"
                alt="吉林省软件行业协会"
                class="w-full h-auto rounded-xl shadow-lg"
              >
              <div class="mt-8 text-center">
                <h3 class="text-2xl font-bold text-gray-800">吉林省软件行业协会</h3>
                <!-- <p class="text-gray-500 mt-2">Information System Platform</p> -->
              </div>
            </div>
          </div>

          <div class="w-full max-w-md fade-in-up" style="animation-delay: 0.4s;">
            <div class="login-card p-8">
              <div class="text-center mb-8">
                <h2 class="text-2xl font-bold text-gray-800">用户注册</h2>
                <p class="text-gray-500 mt-1">USER REGISTER</p>
              </div>

              <form @submit.prevent="handleRegister">
                <div class="input-container">
                  <i class="fa fa-user input-icon"></i>
                  <input
                    type="text"
                    id="username"
                    class="form-input"
                    placeholder="请输入账号"
                    maxlength="20"
                    v-model="username"
                    @input="errors.username = null"
                  >
                  <div v-if="errors.username" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.username }}
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-lock input-icon"></i>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    id="password"
                    class="form-input"
                    placeholder="请输入密码"
                    maxlength="20"
                    v-model="password"
                    @input="errors.password = errors.confirmPassword = null"
                  >
                  <button
                    type="button"
                    class="password-toggle"
                    @click="togglePasswordVisibility"
                    title="{{ showPassword ? '隐藏密码' : '显示密码' }}"
                  >
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </button>
                  <div v-if="errors.password" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.password }}
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-lock input-icon"></i>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    id="confirmPassword"
                    class="form-input"
                    placeholder="请确认密码"
                    maxlength="20"
                    v-model="confirmPassword"
                    @input="errors.confirmPassword = null"
                  >
                  <button
                    type="button"
                    class="password-toggle"
                    @click="togglePasswordVisibility"
                    title="{{ showPassword ? '隐藏密码' : '显示密码' }}"
                  >
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </button>
                  <div v-if="errors.confirmPassword" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.confirmPassword }}
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-user input-icon"></i>
                  <input
                    type="text"
                    id="contact"
                    class="form-input"
                    placeholder="请输入联系人"
                    maxlength="20"
                    v-model="contact"
                  >
                  <div v-if="errors.contact" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.contact }}
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-phone input-icon"></i>
                  <input
                    type="tel"
                    id="phone"
                    class="form-input"
                    placeholder="请输入联系人手机号"
                    maxlength="11"
                    v-model="phone"
                  >
                  <div v-if="errors.phone" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.phone }}
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-shield input-icon"></i>
                  <div class="captcha-container">
                    <input
                      type="text"
                      id="smsCode"
                      class="form-input"
                      placeholder="请输入短信验证码"
                      maxlength="6"
                      v-model="smsCode"
                    >
                    <button
                      type="button"
                      class="btn-sms h-12 px-4 bg-primary text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      @click="sendSmsCode"
                      :disabled="isSending"
                    >{{ isSending ? `${countdown}秒后重发` : '发送验证码' }}</button>
                  </div>
                  <div v-if="errors.smsCode" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.smsCode }}
                  </div>
                </div>

                <div class="flex justify-end mb-6">
                  <button
                    type="button"
                    class="text-blue-600 hover:text-blue-800 transition-colors"
                    @click="goToLogin"
                  >
                    已有账号？去登录
                  </button>
                </div>

                <button type="submit" class="btn-primary">注册</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
    <AppFooter />

    <!-- 通知组件 -->
    <div
      v-show="notification.show"
      class="notification"
      :class="notification.type"
    >
      {{ notification.message }}
    </div>
  </div>
</template>

<script>
import LoginHeader from '../components/LoginHeader.vue'
import AppFooter from '../components/Footer.vue'
import { api } from '../api/index.js'

export default {
  name: 'RegisterPage',
  components: {
    LoginHeader,
    AppFooter
  },
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      contact: '',
      phone: '',
      smsCode: '',
      uuid: '',
      isSending: false,
      countdown: 60,
      showPassword: false,
      errors: {},
      notification: {
        show: false,
        message: '',
        type: 'info'
      }
    }
  },
  methods: {
    async sendSmsCode() {
      // 验证用户名
      if (!this.username.trim()) {
        this.errors.username = '请填写用户账号'
        return
      }

      // 验证密码
      if (!this.password) {
        this.errors.password = '请填写登录密码'
        return
      } else if (this.password.length <= 4 || this.password.length >= 20) {
        this.errors.password = '密码长度应大于4位且小于20位'
        return
      }

      // 验证确认密码
      if (!this.confirmPassword) {
        this.errors.confirmPassword = '请确认密码'
        return
      } else if (this.confirmPassword !== this.password) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        return
      }

      // 验证联系人
      if (!this.contact.trim()) {
        this.errors.contact = '请填写联系人'
        return
      }

      // 验证手机号
      if (!this.phone.trim()) {
        this.errors.phone = '请输入联系人手机号'
        return
      }

      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.errors.phone = '请输入有效的手机号'
        return
      }

      // 验证用户名是否存在
      try {
        const validateResult = await api.validateUsername(this.username)
        if (!validateResult.is_available) {
          this.errors.username = '该用户名已存在，请更换'
          return
        }
      } catch (error) {
        console.error('用户名验证失败:', error)
        this.showNotification(error.message || '用户名验证失败，请稍后重试', 'error')
        return
      }

      this.isSending = true

      try {
        const data = await api.sendSmsCode(this.username, this.phone)
        if (data.code === 200) {
          this.uuid = data.uuid
          this.showNotification('短信验证码已发送到您的手机', 'success')
        } else {
          this.showNotification(data.msg || '发送验证码失败', 'error')
          this.isSending = false
          return
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.showNotification('网络错误，请稍后重试', 'error')
        this.isSending = false
        return
      }

      // 倒计时
      let timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
          this.isSending = false
          this.countdown = 60
        }
      }, 1000)
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      if (!this.username.trim()) {
        this.errors.username = '请填写用户账号'
        isValid = false
      }

      if (!this.password) {
        this.errors.password = '请填写登录密码'
        isValid = false
      } else if (this.password.length <= 4 || this.password.length >= 20) {
        this.errors.password = '密码长度应大于4位且小于20位'
        isValid = false
      }

      if (!this.confirmPassword) {
        this.errors.confirmPassword = '请确认密码'
        isValid = false
      } else if (this.confirmPassword !== this.password) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        isValid = false
      }

      if (!this.contact.trim()) {
        this.errors.contact = '请填写联系人'
        isValid = false
      }

      if (!this.phone.trim()) {
        this.errors.phone = '请填写联系人手机号'
        isValid = false
      } else if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.errors.phone = '请输入有效的手机号'
        isValid = false
      }

      if (!this.smsCode.trim()) {
        this.errors.smsCode = '请填写短信验证码'
        isValid = false
      } else if (this.smsCode.length !== 6) {
        this.errors.smsCode = '短信验证码为6位数字'
        isValid = false
      }

      return isValid
    },
    async handleRegister() {
      if (!this.validateForm()) {
        return
      }

      if (!this.uuid) {
        this.showNotification('请先发送短信验证码', 'error')
        return
      }

      try {
        const data = await api.register(this.username, this.password, this.smsCode, this.uuid, this.contact, this.phone)
        if (data.code === 200) {
          this.showNotification('注册成功！', 'success')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        } else {
          this.showNotification(data.msg || '注册失败', 'error')
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.showNotification(error.message || '网络错误，请稍后重试', 'error')
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    goToLogin() {
      this.$router.push('/login')
    },
    showNotification(message, type = 'info') {
      this.notification = {
        show: true,
        message,
        type
      }
      setTimeout(() => {
        this.hideNotification()
      }, 2000)
    },
    hideNotification() {
      this.notification.show = false
    }
  },
  mounted() {
    // 初始化操作
  }
}
</script>

<style scoped>
.register-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #374151;
  background-color: #f8fafc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.login-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #4B60E7;
}

.login-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1);
}

.input-container {
  position: relative;
  margin-bottom: 24px;
}

.input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 16px;
  transition: all 0.3s ease;
  z-index: 2;
}

.form-input {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px 12px 48px;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 100%;
  background-color: white;
}

.form-input:focus {
  outline: none;
  border-color: #4B60E7;
  box-shadow: 0 0 0 3px rgba(75, 96, 231, 0.1);
}

.form-input:hover {
  border-color: #4B60E7;
}

.btn-primary {
  background-color: #4B60E7;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  display: inline-block;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(75, 96, 231, 0.2);
  width: 100%;
}

.btn-primary:hover {
  background-color: #3A4FB8;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(75, 96, 231, 0.3);
}

.captcha-container {
  display: flex;
  gap: 12px;
}

.captcha-image {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #4B60E7;
  transition: all 0.3s ease;
  user-select: none;
  border: 1px solid #e2e8f0;
  min-width: 100px;
}

.captcha-image:hover {
  background-color: #e2e8f0;
  border-color: #4B60E7;
}

.btn-sms {
  font-size: 12px;
  white-space: nowrap;
  min-width: 100px;
}

.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
}

.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  z-index: 2;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #4B60E7;
}

.password-toggle:focus {
  outline: none;
  color: #4B60E7;
}



@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out forwards;
}

@media (max-width: 768px) {
  .login-card {
    margin: 0 16px;
    padding: 32px 24px;
  }

  .form-input {
    padding: 14px 18px 14px 48px;
    font-size: 16px;
  }

  .captcha-image {
    min-width: 100px;
    padding: 14px 16px;
  }

  .input-icon {
    left: 16px;
  }

  .btn-primary {
    padding: 14px 20px;
    font-size: 16px;
  }

  .form-input,
  .btn-primary,
  .captcha-image {
    -webkit-tap-highlight-color: transparent;
    min-height: 44px;
  }
}

@media (max-width: 480px) {
  .login-card {
    margin: 0 12px;
    padding: 24px 20px;
  }

  .input-container {
    margin-bottom: 20px;
  }

  .captcha-container {
    gap: 12px;
  }

  .captcha-image {
    min-width: 80px;
    padding: 12px 8px;
  }
}

/* 通知组件样式 */
.notification {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px 24px;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 1;
  transition: opacity 0.5s ease-out;
}

.notification[style*="display: none"] {
  opacity: 0;
}

.notification.info {
  background-color: #4B60E7;
}

.notification.success {
  background-color: #10B981;
}

.notification.error {
  background-color: #EF4444;
}
</style>
